import FizConfig from "./FizConfig.ts";
import {OS} from "./lib/os.ts";

declare global {
  interface Window {
    dataLayer: any[];
    OnetrustActiveGroups?: string;
  }
}

window.dataLayer = window.dataLayer || [];
function gtag(...args: any[]): void {
  window.dataLayer.push(args);
}

gtag('js', new Date());

if(FizConfig.GOOGLE_ANALYTICS_GTM){
  //WARNING OneTrust define an observer on those script
  //but it does not intercept insertAdjacentElement
  var GA_ADDED = false;
  function addGAIfAllowed(): void {
    if(GA_ADDED) return;
    if(typeof window.OnetrustActiveGroups === 'string' && window.OnetrustActiveGroups.includes('C0002')){
      gtag({'gtm.start':new Date().getTime(),event:'gtm.js'});
      let script = document.createElement('script')
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtm.js?id="+FizConfig.GOOGLE_ANALYTICS_GTM;

      document.head.appendChild(script);
      GA_ADDED = true;
    }
  }
  addGAIfAllowed()
  if(!GA_ADDED) window.addEventListener('OneTrustGroupsUpdated', addGAIfAllowed);
}


document.addEventListener('click', function (e: MouseEvent) {
  const el = (e.target as HTMLElement).closest('[data-ga-event]') as HTMLElement;
  if (el) {
    event(el.getAttribute('data-ga-event')!);
  }
});
export function page(pageName: string, title?: string): void {
  gtag('set', 'page_path', pageName);
  gtag('set', 'page_location', window.location);
  if(title){
    gtag('set', 'page_title', title);
  }
  gtag('event', 'page_view');
}

export function pageNew(page_path: string, page_title: string): void {
  gtag({
    event:'page_view',
    page_path,
    page_title,
    page_location:window.location
  });
}
//send event which should look like this Category|Action|Label
export function event(eventParam: string | Record<string, any>): void {
  let processedEvent: any = eventParam;
  if(typeof eventParam === 'string'){
    processedEvent = {event:eventParam.replace("$DEVICE",OS.code)}
  }
  window.dataLayer.push(processedEvent);
}

export function invitationevent(eventAsString: string): void {
  event(eventAsString);
}
